import {useBookInfo} from "@/modules/reader/book/bookinfo";
/**
 * Update filename if multiple speech.
 * e.g. filename = myaudio.mp3, make it myaudio_YY.mp3  or myaudio_PN.mp3 according to current speech
 * @param fullPath
 * @returns {string|*}
 */
const updateFileNameIfMultipleSpeech = (fullPath)=> {

    const { bookInfoState} = useBookInfo();
    //if only single speech, no need to inject speech code to filename
    //console.log("updateFileNameIfMultipleSpeech")
    //console.log(bookInfoState)
    if (bookInfoState.availableSpeech.length === 1) {
        return fullPath;
    } else {

        let components =  fullPath.split("/");
        let filename = components.pop();
        filename = `${filename.split(".")[0]}_${bookInfoState.activeSpeech}.${filename.split(".")[1]}`;
        return `${components.join("/")}/${filename}`;

    }
}

//TODO: handle if path does not have other params  ,i.e. & changed to ?
const appendAccessToken = (path) => {

    //if (process.env.VUE_APP_MODE === "local") {
    if (false) {
        return path;
    } else {
        if (path.indexOf("?") === -1) {
            return `${path}?access_token=${localStorage.accessToken}`;
        } else {
            return `${path}&access_token=${localStorage.accessToken}`;
        }
    }
}

/**
 * Check if file exits
 * @param urlToFile
 * @returns {boolean}
 */
const isFileExist = (urlToFile)=> {
    let xhr = new XMLHttpRequest();
    xhr.open("HEAD", urlToFile, false);
    xhr.send();

    if (xhr.status == "404") {
        return false;
    } else {
        return true;
    }
}


/**
 * Append random number and timestamp to url to prevent cache.
 * @param link
 * @returns {string}
 */
const appendUncached = (link)=>{

    let splitter = (link.indexOf("?") >= 0) ? "&" : "?";
    return `${link}${splitter}t=${new Date().getTime()}&r=${Math.random(30000)}`
}


/**
 * Staging server (.23) doesn't return 206 status for mp3 files, causing duration unable to read on iOS tablet....
 * Resolved by replacing it with production path
 * @param path
 */
const replaceAudioPathForStagingServer  = (path) => {
    /*
    if (process.env.VUE_APP_MODE === "dev" || process.env.VUE_APP_MODE === "staging") {
        let newPath = path.replace("ireader/uploads", 'ebook');
        return newPath;
    }*/

    if (process.env.VUE_APP_MODE !== "release" && process.env.VUE_APP_MODE !== "releaseuat") {
        let newPath = path.replace("dist", "https://ireader.hkep.com/ebook_package/");
        newPath = newPath.replace("https://dev.hkep.com/ireader/uploads/", "https://ireader.hkep.com/ebook_package/");
        return newPath;
    }

    return path;

}


export {
    updateFileNameIfMultipleSpeech,
    appendAccessToken,
    isFileExist,
    appendUncached,
    replaceAudioPathForStagingServer
}